/* eslint-disable react/prop-types */
import React from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Pie } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels)

const SpiderChart = ({ labels, displayData }) => {
  // Chart Data
  const chartData = {
    labels: labels,
    datasets: [
      {
        data: [120, 120, 120, 120, 120, 120, 120, 120],
        hoverBackgroundColor: ['rgba(0, 169, 72, 0.8)'],
        backgroundColor: '#0C690D',
        borderColor: 'black',
        borderWidth: 1
      }
    ]
  }

  // config
  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        enabled: true,
        callbacks: {
          label: function() {
            return ''
          }
        }
      },
      legend: {
        display: false
      },
      datalabels: {
        color: 'white',
        font: {
          size: 16,
          weight: 'bold'
        },
        formatter: (value, context) => {
          const index = context.dataIndex
          const dataForThisIndex = displayData[index]
          return dataForThisIndex
        }
      }
    }
  }

  return <Pie data={chartData} options={options} />
}

export default SpiderChart
